import { AngularEditorConfig } from "@kolkov/angular-editor";

export const USER_KEY = 'current-user';
export const ANGULAR_EDITOR_CONFIG: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: '15rem',
    minHeight: '5rem',
    translate: 'now',
    defaultParagraphSeparator: 'p',
    sanitize: false,
    toolbarHiddenButtons: [
        ['insertVideo', 'link', 'unlink']
    ],

};
export const ANGULAR_EDITOR_READONLY: AngularEditorConfig = {
    editable: false,
    showToolbar: false
};
export const TELEPHONE_REGEX = /^\+?[0-9]{0,15}$/;
export const DEBOUNCE_TIME_INPUT = 500;
export const MODAL_MIN_WIDTH = 300;